export const TABLE_FIELDS = [
   "columnKey",
   "titleTranslationKey",
   "valuePrefix",
   "valueSuffix",
   "valueDescriptionTranslationKey",
   "valueLimit",
   "valueLimitDescriptionTranslationKey",
];

export type ColumnMapping = {
   id?: string;
   indicator_name?: string;
   indicator_prefix?: string;
   indicator_value?: string;
   indicator_suffix?: string;
   indicator_completion_prefix?: string;
   indicator_completion_value?: string;
   indicator_completion_suffix?: string;
   indicator_completion_percent?: string;
   indicator_board_link?: string;
};

export type SummariesValue = Record<string, unknown> & {
   columnSummaries?: Summary[];
   columnMapping?: ColumnMapping;
   mode?: Mode;
   listId?: string;
};

export type Field = (typeof TABLE_FIELDS)[number];

export type Summary = {
   id: string | null;
   columnKey: string | { value: string; label: string } | null;
   titleTranslationKey?: string;
   valuePrefix: string;
   valueSuffix: string;
   valueDescriptionTranslationKey: string;
   valueLimit: number;
   valueLimitDescriptionTranslationKey: string;
};

export type Mode = "external" | "summary";

export type ModeOption = {
   label: string;
   value: Mode;
};

export type SummaryTable = {
   cols: {
      options: {
         techName: string;
         sumAllRecords?: number;
         sumAllValues?: boolean;
      };
      label: string;
      meta?: {
         hid: string;
      };
   }[];
   rows: Record<string, unknown>[];
};
